import { useState, useEffect } from "react";
import styles from "./ForgotPassword.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotPassword,
  clearError,
  clearForgotState,
} from "../../../store/slices/authSlice";
import { toast } from "react-toastify";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { otpLoading, forgotOtpSent, error } = useSelector((s) => s.auth);

  const [email, setEmail] = useState("");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (!forgotOtpSent) return;
    dispatch(clearForgotState());
    toast.success(" تم إرسال كود التحقق على بريدك!", {
      autoClose: 2000,
      position: "top-center",
    });
    navigate("/forgot-verify-otp", { state: { email: email.trim() } });
  }, [forgotOtpSent]);

  useEffect(() => {
    if (!error) return;
    toast.error(
      ` ${typeof error === "string" ? error : "البريد الإلكتروني غير مسجل"}`,
      {
        position: "top-center",
      },
    );
    dispatch(clearError());
  }, [error, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError("");
    if (!email.trim()) return setLocalError("البريد الإلكتروني مطلوب");
    dispatch(forgotPassword(email.trim()));
  };

  return (
    <div className={styles.ForgotContainer}>
      <div className={styles.ForgotCard}>
        <img src="/os-logo.png" alt="logo" />

        <h2>{t("forgotPassword.title")}</h2>
        <p className={styles.desc}>{t("forgotPassword.desc")}</p>

        {localError && (
          <div className={styles.errorBanner}> {localError}</div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className={styles.inputGroup}>
            <label htmlFor="email">
              {t("forgotPassword.email") || "البريد الإلكتروني"}
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setLocalError("");
              }}
              placeholder="example@email.com"
              required
            />
          </div>

          <button
            type="submit"
            className={`${styles.button} ${styles.buttonForgot}`}
            disabled={otpLoading}
          >
            {otpLoading
              ? " جاري الإرسال..."
              : t("forgotPassword.sendCode") || "إرسال كود التحقق"}
          </button>
        </form>

        <button
          type="button"
          className={styles.backLink}
          onClick={() => navigate("/login")}
        >
          ← {t("forgotPassword.backToLogin") || "العودة لتسجيل الدخول"}
        </button>
      </div>
    </div>
  );
}
